import { styled } from "@mui/material/styles";

// Components
import { Grid, FormControl } from "@mui/material";

// Icons
import Icon from "~/assets/icons/logo.png";

const styleName = "LoginForm";

export const StyledLoginIcon = styled("div", { name: styleName })({
  "&": {
    backgroundImage: `url(${Icon})`,
    height: "180px",
    width: "180px",
    border: "none",
    margin: "20px auto 0 auto",
    backgroundSize: "contain",
    display: "block",
  },
});

export const StyledFormLink = styled(Grid, { name: styleName })({
  "&": {
    display: "flex",
    justifyContent: "space-between",
  },
});

export const StyledSignUpLink = styled(Grid, { name: styleName })({
  "&": {
    display: "flex",
    justifyContent: "center",
    marginTop: "30px",
  },
});

export const StyledLoginButton = styled(FormControl, { name: styleName })({
  "&": {
    marginBottom: "22px",
  },
});

export const StyledButton = styled(FormControl, { name: styleName })({
  "&": {
    marginBottom: "8px",
  },
});
